<style lang="less">
.acctplus_info{
	padding-bottom: 54px;
	.disable{
		color: #999;
	}
}
</style>

<template>
	<!-- Main acctplus_info -->
	<section class="acctplus_info">
		<div class="form">
			<div class="item">
				<div class="label">姓名</div>
				<div class="cont">
					<input type="text" value="" placeholder="真实姓名" v-model="info.holder_name" disabled="disabled" class="disable" v-if="isIdentity.holder_name" />
					<input type="text" value="" placeholder="真实姓名" v-model="info.holder_name" maxlength="12" v-else />
				</div>
			</div>
			<div class="item">
				<div class="label">身份证号</div>
				<div class="cont">
					<input type="text" value="" placeholder="身份证号将加密处理" v-model="info.cert_no" disabled="disabled" class="disable" v-if="isIdentity.cert_no" />
					<input type="text" value="" placeholder="身份证号将加密处理" v-model="info.cert_no" maxlength="18" v-else />
				</div>
			</div>
			<div class="explain">请填写本人身份信息，绑定后无法修改</div>
		</div>
		<div class="form_space"></div>
		<div class="form">
			<div class="tips" v-show="tips">{{tips}}</div>
		</div>

		<footbtn btn-txt="下一步" :is-on="isActive" @click.native="next"></footbtn>

	</section>
</template>

<script>
	import android from '@flyme/jr/js/android.js';
	import item from '@flyme/jr/flyme7/component/item/vue-item.vue';
	import footbtn from '@flyme/jr/flyme7/component/foot-btn-simple/foot-btn-simple.vue';
	import poplist from '@flyme/jr/flyme7/component/pop-list/pop-list.vue';
	import itembank from '../components/itembank.vue';

	import axios from '../axios.js';
	import apis from '../apis.js';
	import config from '../config.js';
	import smscode from '../components/smscode.vue';

	export default {
		data: function() {
			return {
				tips: '',
				bank: {
					index: -1,
					isShow: false,
					data: []
				},
				info: {
					user_id: '',
					partner_id: config.partner_id,
					partner_cp_type: config.partner_cp_type,
					bacc_no_i: '',
					bacc_no_l4: '',
					bacc_no: '',
					acc_type: '',
					bank_name: '',
					holder_name: '',
					bank_code: '',
					cert_no: '',
					phone: '',
					token: '',
					verify_code: ''
				},
				isIdentity: {
					holder_name: '',
					cert_no: '',
					phone: ''
				}
			};
		},
		computed: {
			isActive: function() {
				return true;
			}
		},
		components: {
			item,
			itembank,
			smscode,
			footbtn,
			poplist
		},
		created: function () {
			this.getUserInfo();
			this.getPerFill();
		},
		mounted: function() {},
		methods: {
			getUserInfo: function () {
				let _this = this;
				android('getUserInfo', {}, function (d) {
					_this.info.user_id = d.userId;
				});
			},
			getPerFill: function () {
				let _this = this;
				axios.post(apis.identity_query, {}).then(function(d) {
					console.log('identity_query', d);
					if (d.value) {
						_this.info.holder_name = d.value.user_name;
						_this.info.cert_no = d.value.cert_no;
						_this.isIdentity.holder_name = d.value.user_name;
						_this.isIdentity.cert_no = d.value.cert_no;
					}else{
						_this.isIdentity.holder_name = '';
						_this.isIdentity.cert_no = '';
					}
				});
			},
			next: function () {
				this.$router.push({ path: '/verify' });
			}
			// next: function () {
			// 	let _this = this;
			// 	axios.post(apis.bank_bind, this.info).then(function(d) {
			// 		console.log('bank_bind', d);
			// 		android('hideLoadingDialog');
			// 		if (d.code != 200) {
			// 			_this.tips = d.message;
			// 		}else{
			// 			if (d.value.result) {
			// 				_this.$router.push({path: '/acctplus/identity'});
			// 			}
			// 		}
			// 	});
			// }
		}
	};
</script>


// WEBPACK FOOTER //
// src/pages/Acctplus_info.vue